
export default {
  SAVE (state, unities) {
    state.unities = unities
  },
}
